import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useUpdateEmail } from '../../../useQuery';
import { useNotification } from '../../../hooks';

const EmailTab = ({ suite }) => {
  const [email, setEmail] = useState('');
  const notify = useNotification();


  useEffect(() => {

    if (suite?.resultsEmail) {
      setEmail(suite.resultsEmail);
    }
  }, [suite]);

  const { mutate: updateEmail, isPending } = useUpdateEmail({
    onSuccess: () => {
      notify("Email updated successfully", "success");
    },
    onError: (error) => {
      notify(error.message || "Failed to update email", "error");
    }
  });

  const handleSubmit = () => {
    if (!email.trim()) {
      notify("Please enter an email address", "error");
      return;
    }

    if (!suite?.id) {
      notify("Suite ID not found", "error");
      return;
    }

    updateEmail({
      testSuiteId: suite.id,
      email: email.trim()
    });
  };

  return (
    <Box className="font-apple">
      <div className="mb-4">
        <p className="text-sm text-gray-600 mb-2">
          Enter the email address where you want to receive suite execution results
        </p>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter email address"
          className="w-full px-3 py-2 text-sm border border-gray-200 rounded focus:outline-none focus:border-blue-400"
        />
      </div>

      <div className="flex justify-end mt-6">
        <button
          onClick={handleSubmit}
          disabled={isPending}
          className={`px-4 py-2 text-sm bg-blue-600 text-white hover:bg-blue-700 transition-colors rounded cursor-pointer ${
            isPending ? 'opacity-50 cursor-not-allowed' : ''
          }`}
        >
          {isPending ? 'Saving...' : 'Save Email'}
        </button>
      </div>
    </Box>
  );
};

export default EmailTab;
